import React, { Component } from 'react';
import renderSocialLinks from '../utils/renderSocialLinks';
import renderStoreInfo from '../utils/renderStoreInfo';

const Rodape = ({ revenda }) => {
  return (
    <footer className="footer-3 footer-topbar light page-section-pt">
      <div className="container">
        <div className="row top">
          <div className="col-lg-3 col-md-12">
            <img
              className="img-fluid"
              id="logo_footer_dark"
              src="images/logo.png"
              alt=""
            />
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="social text-lg-right text-center">
              <ul>{renderSocialLinks(revenda)}</ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <hr />
          </div>
        </div>
        <div className="row" style={{ display: "flex", justifyContent: "center", textAlign: "center" }}>
          <div className="col-lg-5 col-md-12">
            <div className="about-content">
              <h6 className="text-sobrenos">Sobre nós</h6>
              <p className="text-sobrenos-info">
                A FR Multimarcas é a escolha certa para quem busca qualidade, variedade e ótimo atendimento na compra de veículos. Trabalhamos com uma ampla seleção de carros novos e seminovos de diversas marcas, sempre oferecendo preços justos e condições especiais de pagamento.             </p>
            </div>
          </div>
          <div className="col-lg-7 col-md-12">
            <h6 className="text-sobrenos">Informações da loja</h6>
            <ul className="text-sobrenos-info">{renderStoreInfo(revenda)}</ul>
          </div>
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <div className="row" style={{ display: "flex", justifyContent: "center" }}>
            <div className="col-lg-6 col-md-12">
              <div className="text-lg-left text-center">
                <p style={{ textAlign: "center" }}>
                  © Copyright 2025 FR Multimarcas | Todos os direitos reservados.
                  <a href="https://intermedioveiculos.com.br/" target="HKe2fZ02jqcU0ixfKIxz"
                  > Intermédio Veículos Marketing Digital</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

  );
}

export default Rodape;